import {useEffect, useState} from 'react';
import {db} from '../config/firebase';
import {
  collection, query, where,
  getDocs, doc, getDoc, updateDoc, onSnapshot,
} from 'firebase/firestore';

export const useNotifications = (userId) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadNotifications, setUnreadNotifications] = useState(false);

  const markAllAsRead = async () => {
    const q = query(
      collection(db, 'notifications'),
      where('recipientId', '==', userId),
    );
    const snap = await getDocs(q);
    for (const docSnap of snap.docs) {
      await updateDoc(docSnap.ref, {read: true, readAt: new Date()});
    }
    setUnreadNotifications(false);
  };

  useEffect(() => {
    if (!userId) return;
    const q = query(
      collection(db, 'notifications'),
      where('recipientId', '==', userId),
    );
    const unsub = onSnapshot(q, async (snap) => {
      const list = snap.docs.map((d) => ({id: d.id, ...d.data()}));
      const withNames = await Promise.all(
        list.map(async (n) => {
          const senderDoc = await getDoc(doc(db, 'users', n.senderId));
          const senderData = senderDoc.data() || {};
          return {
            ...n,
            senderName: senderData.userName || senderData.name || 'Alguien',
          };
        }),
      );
      setNotifications(withNames);
      setUnreadNotifications(withNames.some((n) => !n.read));
    });
    return () => unsub();
  }, [userId]);

  return {notifications, unreadNotifications, markAllAsRead};
};